import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) { navigate("/auth"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sid } });
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/tableau-de-bord", { replace: true });
      } catch (e) {
        setError("Échec de la connexion Google. Veuillez réessayer.");
        setTimeout(() => navigate("/auth"), 2000);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4" data-testid="auth-callback">
      {error ? (
        <p className="text-congo-red font-medium">{error}</p>
      ) : (
        <>
          <Loader2 className="h-8 w-8 animate-spin text-congo-blue" />
          <p className="text-muted-foreground">Connexion en cours…</p>
        </>
      )}
    </div>
  );
}
